// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "month-2ArR3 month-3_c1h";
var _5 = "week-3JYtP";
var _6 = "week_withPrice-2TJhv";
var _7 = "monthWrapper-1HcnT";
export { _1 as "__esModule", _2 as "tablet", _3 as "tablet_only", _4 as "month", _5 as "week", _6 as "week_withPrice", _7 as "monthWrapper" }
export default { "__esModule": _1, "tablet": _2, "tablet_only": _3, "month": _4, "week": _5, "week_withPrice": _6, "monthWrapper": _7 }
